import React from "react";

interface ArrowsIconProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const MenuDotsIcon: React.FC<ArrowsIconProps> = (props) => {
  return (
    <svg
      width={props.width ?? "24"}
      height={props.height ?? "41"}
      viewBox="0 0 24 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <path
        d="M12 21.79C12.5523 21.79 13 21.3423 13 20.79C13 20.2378 12.5523 19.79 12 19.79C11.4477 19.79 11 20.2378 11 20.79C11 21.3423 11.4477 21.79 12 21.79Z"
        stroke={props.fill || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21.79C19.5523 21.79 20 21.3423 20 20.79C20 20.2378 19.5523 19.79 19 19.79C18.4477 19.79 18 20.2378 18 20.79C18 21.3423 18.4477 21.79 19 21.79Z"
        stroke={props.fill || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 21.79C5.55228 21.79 6 21.3423 6 20.79C6 20.2378 5.55228 19.79 5 19.79C4.44772 19.79 4 20.2378 4 20.79C4 21.3423 4.44772 21.79 5 21.79Z"
        stroke={props.fill || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MenuDotsIcon;
